import React from 'react'

const PropsList = ({systemProps}) => {
  return (
    <>
      {systemProps.propNames.map(prop => {
        return <code key={prop}>{prop}, </code>
      })}
    </>
  )
}

export default PropsList
